module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3cjqQb67yRsxTciY0qWzVb-919a89954c5ad6c8a87cf199e0653190.jpg";